import { createContext, useCallback, useEffect, useState } from 'react';
import TagManager from 'react-gtm-module';
import { AnalyticsContextProps, AnalyticsProviderProps } from '.';

export const AnalyticsContext = createContext<AnalyticsContextProps | undefined>(undefined);

export const AnalyticsProvider: React.FC<AnalyticsProviderProps> = ({ children }) => {
    const [hasFiredAnalytics, setHasFiredAnalytics] = useState(false);
    useEffect(() => {
        const gtmId = import.meta.env.VITE_GTM_ID;

        if (gtmId) {
            TagManager.initialize({
                gtmId,
                dataLayerName: 'dataLayer',
            });
        }
    }, []);

    const pushEvent = useCallback((data: TagManager.DataLayerArgs['dataLayer']) => {
        const pushEvent = {
            dataLayer: {
                event: 'clientReportingTool',
                eventCategory: 'Report details',
                ...data,
            },
        };
        TagManager.dataLayer(pushEvent);
    }, []);

    const resetAnalytics = useCallback(() => {
        setHasFiredAnalytics(false);
    }, []);

    return (
        <AnalyticsContext.Provider value={{ pushEvent, hasFiredAnalytics, setHasFiredAnalytics, resetAnalytics }}>
            {children}
        </AnalyticsContext.Provider>
    );
};
